export default __webpack_public_path__ + "c3bbfeffd1108cee330c932d2c2fa998.png";